<template>
  <div class="headline_text">
    <h1 class="entry-title">{{ headline }}</h1>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Headline',
  computed: {
    ...mapState(['headline']),
  },
}
</script>
